// WHAT: Thin-Wrapper um `ScoreCard` für den Oura-Sleep-Score
// WHY:  Sorgt für eine eigenständige, semantisch benannte Sleep-Score-Komponente im Oura-Dashboard
// DOMAIN: health → oura → molecules
// DEPENDENCIES: `ScoreCard`-Molecule
import { type FC } from "react";

import { ScoreCard } from "./ScoreCard";

interface SleepScoreProperties {
  score: number;
  trend?: "down" | "stable" | "up";
  trendValue?: number;
}

export const SleepScore: FC<SleepScoreProperties> = ({ score, trend, trendValue }) => {
  return (
    <ScoreCard
      description="Quality of your sleep"
      maxScore={100}
      score={score}
      title="Sleep Score"
      {...(trend !== undefined && { trend })}
      {...(trendValue !== undefined && { trendValue })}
    />
  );
};
